<template>
    <svg viewBox="0 0 1306 894" class="hero-strategy-shapes hero-strategy-shapes--desktop" aria-hidden="true">
        <path :d="shapePaths.s" class="hero-strategy-shapes__path hero-strategy-shapes__path--s" />
        <path :d="shapePaths.m" class="hero-strategy-shapes__path hero-strategy-shapes__path--m" />
        <path :d="shapePaths.l" class="hero-strategy-shapes__path hero-strategy-shapes__path--l" />

        <mask :id="maskId" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="552" y="-2013" width="1248" height="2783">
            <path
                d="M1530.52 -1996.56C1221.49 -2076.2 1110.25 -1836.34 1059.66 -1640.06L581.823 214.067C531.247 410.322 512.716 674.088 821.712 753.717C1130.74 833.365 1241.99 593.497 1292.57 397.229L1770.41 -1456.89C1820.98 -1653.15 1839.51 -1916.92 1530.52 -1996.55L1530.52 -1996.56Z"
                fill="#D9D9D9"
            />
        </mask>
        <g :mask="`url(#${maskId})`">
            <rect x="346.424" y="56.7693" width="1069.13" height="712.752" fill="url(#pattern0)" />
            <rect x="213.965" y="-68.3303" width="621.293" height="843.108" :fill="imageGradientFill" />
        </g>
        <defs>
            <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use :href="`#${imageId}`" transform="scale(0.0004 0.0006)" />
            </pattern>
            <linearGradient v-if="imageUrl" :id="gradientId" x1="430.559" y1="507.637" x2="835.258" y2="507.637" gradientUnits="userSpaceOnUse">
                <stop offset="0.438273" stop-color="#CBCBCB" />
                <stop offset="1" stop-color="#CBCBCB" stop-opacity="0" />
            </linearGradient>
            <image :id="imageId" width="2500" height="1667" :href="imageUrl ?? undefined" />
        </defs>
    </svg>
    <svg viewBox="0 0 390 185" class="hero-strategy-shapes hero-strategy-shapes--mobile" aria-hidden="true">
        <path
            d="M-69.7704 -224.037C-37.7441 -262.812 -1.34752 -242.529 23.2799 -222.19L255.914 -30.0366C280.537 -9.69829 307.329 22.2171 275.302 60.9857C243.278 99.7599 206.881 79.4799 182.254 59.1386L-50.38 -133.014C-75.0031 -153.352 -101.794 -185.266 -69.7704 -224.037Z"
            class="hero-strategy-shapes__path hero-strategy-shapes__path--mobile-s"
        />
        <path
            d="M151.394 -360.434C205.316 -382.653 231.507 -342.049 245.618 -307.801L378.918 15.7201C393.025 49.9629 403.038 97.2348 349.124 119.451C295.203 141.668 269.01 101.063 254.9 66.8158L121.601 -256.704C107.492 -290.947 97.4781 -338.22 151.394 -360.434Z"
            class="hero-strategy-shapes__path hero-strategy-shapes__path--mobile-m"
        />
        <path
            d="M513.65 -442.688C583.752 -428.651 582.825 -369.423 573.908 -324.898L489.668 95.6946C480.752 140.213 458.793 195.23 388.7 181.192C318.597 167.151 319.523 107.925 328.442 63.4019L412.68 -357.192C421.598 -401.712 443.556 -456.728 513.65 -442.688Z"
            class="hero-strategy-shapes__path hero-strategy-shapes__path--mobile-l"
        />
    </svg>
</template>

<script setup lang="ts">
    import {computed, useId} from 'vue';

    const props = defineProps<{
        imageUrl?: string | null;
    }>();

    const shapePaths = {
        s: 'M577.459 244.719C653.265 205.876 632.986 138.28 608.318 90.1309L375.268 -364.704C350.599 -412.848 307.575 -468.793 231.773 -429.954C155.967 -391.111 176.246 -323.515 200.914 -275.366L433.959 179.472C458.627 227.617 501.652 283.562 577.453 244.723L577.459 244.719Z',
        m: 'M647.768 338.081C765.708 330.376 777.116 233.118 772.223 158.21L725.984 -549.401C721.089 -624.3 697.114 -719.248 579.188 -711.54C461.248 -703.835 449.84 -606.577 454.734 -531.673L500.973 175.937C505.868 250.837 529.843 345.784 647.769 338.077L647.768 338.081Z',
        l: 'M1530.52 -1996.56C1221.49 -2076.2 1110.25 -1836.34 1059.66 -1640.06L581.823 214.067C531.247 410.322 512.716 674.088 821.712 753.717C1130.74 833.365 1241.99 593.497 1292.57 397.229L1770.41 -1456.89C1820.98 -1653.15 1839.51 -1916.92 1530.52 -1996.55L1530.52 -1996.56Z',
    };

    const instanceId = useId();
    const maskId = computed(() => `hero-strategy-mask${instanceId}`);
    const imageId = computed(() => `hero-strategy-image${instanceId}`);
    const gradientId = computed(() => `hero-strategy-gradient${instanceId}`);
    const imageGradientFill = computed(() => (props.imageUrl ? `url(#${gradientId.value})` : 'transparent'));
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .hero-strategy-shapes {
        overflow: visible;
        position: absolute;
        z-index: -1;

        &--mobile {
            right: 0;
            width: 60%;
            top: 0;

            @include mq.screen_md(min) {
                display: none;
            }
        }

        &--desktop {
            right: -10%;
            width: 93%;
            top: -6vh;
            display: none;

            @include mq.screen_md(min) {
                display: block;
            }

            @media screen and (min-width: 1400px) {
                right: -1%;
                top: -58px;
            }
        }

        &__path {
            &--s,
            &--mobile-s {
                fill: var(--joy-color-secondary-30);
            }

            &--m,
            &--mobile-m {
                fill: var(--joy-color-neutral-20);
            }

            &--l,
            &--mobile-l {
                fill: var(--joy-color-secondary-50);
            }
        }
    }
</style>
